module.exports = __webpack_public_path__ + "img/icon-admin.8f1b37bb.svg";